import Icon from '../components/Icon.vue'

Icon.register({"hand-point-down":{"width":384,"height":512,"paths":[{"d":"M91.8 467.2V318C83.6 323.8 75.3 328.5 66.9 332.1 35.1 345.8 0 322.2 0 288 0 269.4 10.9 255.8 29.1 248 57.4 235.9 93.4 169.4 106.4 140.5 114.4 122.6 131.9 112 150.3 112L150.3 112H321.8C333.6 112 343.7 120.6 345.5 132.3 352.7 179.1 384 194 383.8 256 383.8 258.7 384 269.3 384 272 384 322.7 361.9 353.6 312.7 344.6 303.4 363.2 273.3 375.3 250.4 361.1 229.2 385.7 196.5 383.7 179.5 367.3V467.2C179.5 491.4 159.3 512 135.7 512 112.4 512 91.8 490.6 91.8 467.2zM112 72V24C112 10.7 122.7 0 136 0H328C341.3 0 352 10.7 352 24V72C352 85.3 341.3 96 328 96H136C122.7 96 112 85.3 112 72zM324 48C324 37 315 28 304 28S284 37 284 48 293 68 304 68 324 59 324 48z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-point-down.js
// module id = xqUE
// module chunks = 0